import { CommonModule } from '@angular/common'
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, Pipe } from '@angular/core'
//
import { PipesModule } from './pipes/pipes.module'
import { ComponentsModule } from '../components/components.module'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

@NgModule({
    imports: [CommonModule, PipesModule, ComponentsModule, FormsModule, ReactiveFormsModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [PipesModule, ComponentsModule, FormsModule, ReactiveFormsModule],
})
export class GeneralModule {}
